import React from 'react';
import Form from 'react-bootstrap/Form';
import { Col, Container, FormGroup, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { useState, useEffect, useRef } from 'react';
import { Auth, SignOut, ListAppSegments, UpdateAppSegment, ListAppConnectorGroups, UpdateAppConnectorGroup } from '../../../functions/ZPA';
import Spinner from 'react-bootstrap/Spinner';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Multiselect from 'multiselect-react-dropdown';
import Badge from 'react-bootstrap/Badge';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { objectToOperationString } from '../../../functions/misc';
import InputGroup from 'react-bootstrap/InputGroup';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode'
import { groups_object } from '../../tabs';


library.add(faAngleDown)

function DisasterRecoveryTab({ groups, verified, showVerifyWindow, setShowVerifyWindow, setVerifyOperation, setVerified, selectedTab }) {
    const [isLoading, setLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("Authenticating...")
    const [tenant, setTenant] = useState("Rheintec");
    const [outputConsole, setOutputConsole] = useState("");
    const [appSegments, setAppSegments] = useState(groups_object);
    const [appConnectorGroups, setAppConnectorGroups] = useState(groups_object);
    const [filtered, setFiltered] = useState(groups_object);
    const [selected, setSelected] = useState([]);
    const [accessToken, setAccessToken] = useState("");
    const [operation, setOperation] = useState("Enable");
    const textareaRef = useRef();
    const [updated, setUpdated] = useState([]);
    const [failed, setFailed] = useState([]);
    const [target, setTarget] = useState("App Segments")
    const [description, setDescription] = useState("")
    const [descriptionTag, setDescriptionTag] = useState("")

    const multiselectRef = useRef();


    function copyList(list) {
        const text = ListToText(list);
        navigator.clipboard.writeText(text);
    }

    function ListToText(list) {
        let text = "";
        for (let i = 0; i < list.length; i++) {
            text += i === 0 ? list[i] : "\n" + list[i];
        }
        return text;
    }

    function appendConsole(text) {
        setOutputConsole(prevOutput => prevOutput + text);
    }
    function appendConsoleSeperatorMain(skipNewLine) {
        const width = textareaRef.current.clientWidth;
        const dashesCount = Math.floor(width / 8); // Adjust the number as needed
        const dashes = ('-'.repeat(dashesCount));
        setOutputConsole(prevOutput => prevOutput + (skipNewLine ? "" : "\n") + dashes);
    }
    function appendConsoleSeperatorSecondary() {
        const width = textareaRef.current.clientWidth;
        const dashesCount = Math.floor(width / 8); // Adjust the number as needed
        const dashes = ('-'.repeat(dashesCount / 2));
        setOutputConsole(prevOutput => prevOutput + "\n" + "\t" + dashes);
    }

    async function getAppSegments() {
        let newAppSegments = { ...appSegments };
        setAppSegments({ "Rheintec": [], "Helvetia": [], "Credaris": [] })
        Object.keys(appSegments).forEach(async (key) => {
            const access_token = await authenticate(key);
            if (access_token) {
                const app_segments_response = await ListAppSegments(access_token, key)
                const app_segments_json = await app_segments_response.json()

                if (app_segments_response.status === 200) {
                    const app_segments = app_segments_json.app_segments;
                    newAppSegments[key] = app_segments;
                    setAppSegments({ ...newAppSegments });
                }
                else {
                    appendConsole(`\nError: ${app_segments_response.message}`);
                    appendConsoleSeperatorMain();
                }
            }
            SignOut(accessToken)

        });
    }

    async function getAppConnectorGroups() {
        let newAppConnectorGroups = { ...appConnectorGroups };
        setAppConnectorGroups({ "Rheintec": [], "Helvetia": [] })
        Object.keys(appConnectorGroups).forEach(async (key) => {
            const access_token = await authenticate(key);
            if (access_token) {
                const app_connector_groups_response = await ListAppConnectorGroups(access_token, key)
                const app_connector_groups_json = await app_connector_groups_response.json()

                if (app_connector_groups_response.status === 200) {
                    const app_connector_groups = app_connector_groups_json.app_connector_groups;
                    newAppConnectorGroups[key] = app_connector_groups;
                    setAppConnectorGroups({ ...newAppConnectorGroups });
                }
                else {
                    appendConsole(`\nError: ${app_connector_groups_response.message}`);
                    appendConsoleSeperatorMain();
                }
            }

        });

    }

    function filter() {
        setSelected([]);
        let toFilter = target === "App Segments" ? appSegments : appConnectorGroups
        let newfiltered = { ...filtered };
        Object.keys(toFilter).forEach((key) => {
            newfiltered[key] = toFilter[key].filter((appSegment) => operation === "Enable" ? !appSegment.useInDrMode : appSegment.useInDrMode);
        });
        setFiltered(newfiltered);
    }

    async function authenticate(tenant) {
        try {
            const response = await Auth(tenant);
            const auth_json = await response.json();
            if (response.status === 200) {
                const access_token = auth_json.access_token;
                return access_token;
            }
            else {
                appendConsole(`\nAuth Error: ${tenant} - ${auth_json.message}`);
                appendConsoleSeperatorMain();
            }
        }
        catch (error) {
            console.log(error)
            appendConsole(`\nAuth Error: ${tenant} - ${error.message}`);
            appendConsoleSeperatorMain();
        }
    }


    async function handleSubmit(event) {
        const selectedNames = selected.map(element => element.name)
        const obj = {
            "Tenant": tenant,
            "Operation": `${operation} disaster recovery`,
            "Affected Resources": {
                [target]: selectedNames
            }
        }
        if (!verified) {
            try {
                const operationString = objectToOperationString(obj);
                setVerifyOperation(operationString);
                setShowVerifyWindow(true);

            } catch (error) {
                console.log(error)
            } finally {
                event.preventDefault();
                return
            }

        }

        //Prerequisites
        setUpdated([]);
        setFailed([])
        setOutputConsole(``);
        setLoading(true);
        event.preventDefault();

        //Authenticate
        setLoadingMessage("Initiating Session...");
        const access_token = await authenticate(tenant);
        setAccessToken(access_token);
        setOutputConsole(`Authenticated`);
        appendConsoleSeperatorMain();
        try {
            appendConsole(`\n${selected.filter((element) => element.name != "Select All").length} ${target === "App Segments" ? "app segment(s)" : "app connector group(s)"} detected`);
            appendConsoleSeperatorMain();

            for (const element of selected) {
                if (element.name === "Select All") {
                    continue;
                }
                try {
                    let response = target === "App Segments" ? await UpdateAppSegment(element, description, true, access_token, tenant) : await UpdateAppConnectorGroup(element, description, access_token, tenant)
                    const response_data = await response.json();
                    if (response.status === 200) {
                        setUpdated((prev) => [...prev, element.name])
                    } else if (response.status === 429) {

                    }
                    else {
                        setFailed((prev) => [...prev, { name: element.name, message: response_data.message }]);
                    }

                }
                catch (error) {
                    console.log(error)
                    setFailed((prev) => [...prev, { name: element.name, message: error.message }]);
                }
            }


        }
        catch (error) {
            appendConsole(`\nError: ${error.message}`)
            console.log(error)
            terminateSession(access_token)
        }



    }

    function evaluateSelect(selectedList, selectedItem) {
        let newSelected;
        if (selectedItem.name === "Select All") {
            console.log(filtered[tenant])
            newSelected = [{ "name": "Select All" }, ...filtered[tenant]]
        }
        else {
            newSelected = selectedList;
        }
        newSelected = newSelected.map((element) => {
            const updatedSegment = {
                ...element,
                useInDrMode: operation === "Enable" ? true : false
            };
            return updatedSegment;
        });
        setSelected(newSelected)

    }

    function evaluateRemove(selectedList, selectedItem) {
        if (selectedItem.name === "Select All") {
            setSelected([])
            return
        }
        setSelected(selectedList)

    }

    // Function to scroll the textarea to the bottom
    const scrollToBottom = () => {
        textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    };

    const scrollToTop = () => {
        textareaRef.current.scrollTop = 0;
    };

    function outputResponseUserStatus() {
        setOutputConsole("");
        appendConsoleSeperatorMain(true);
        appendConsole(`\nUpdated ${updated.length}/${selected.filter((element) => element.name != "Select All").length} ${target === "App Segments" ? "App Segment(s)" : "App Connector Group(s)"}:`);
        if (updated.length === 0) {
            appendConsoleSeperatorSecondary();
            appendConsole(`\n\tNo ${target === "App Segment" ? "App Segments" : "App Connector Groups"} updated :(`)
        }
        for (const element of updated) {
            appendConsoleSeperatorSecondary();
            appendConsole(`\n\tName: ${element}`);
        }
        appendConsoleSeperatorSecondary();
        appendConsoleSeperatorMain();

        appendConsole(`\nFailed ${failed.length}/${selected.filter((element) => element.name != "Select All").length} ${target === "App Segments" ? "App Segment(s)" : "App Connector Group(s)"}:`);
        if (failed.length === 0) {
            appendConsoleSeperatorSecondary();
            appendConsole("\n\tNo app segments failed to update :)")
        }
        for (const fail of failed) {
            appendConsoleSeperatorSecondary();
            appendConsole(`\n\tName: ${fail.name} \n\tReason: ${fail.message}`);
        }
        appendConsoleSeperatorSecondary();
        appendConsoleSeperatorMain();


    }
    useEffect(() => {
        if (selectedTab === "disasterRecovery" && verified) {
            console.log("IN")
            handleSubmit(new Event("LOL"))
        }
        setVerified(false);
    }, [verified])
    useEffect(() => {
        if (failed.length > 0) {
            setLoadingMessage(`Updating ${target}... (${updated.length + failed.length}/${selected.filter((element) => element.name != "Select All").length})`);
            const failedAppSegment = failed[failed.length - 1];
            appendConsoleSeperatorSecondary();
            appendConsole(`\n\tStatus: Failed \n\tName: ${failedAppSegment.name} \n\tReason: ${failedAppSegment.message}`);
            if (updated.length + failed.length == selected.filter((element) => element.name != "Select All").length) {
                terminateSession(accessToken);
                outputResponseUserStatus();
                setSelected([]);
                getAppSegments()
                getAppConnectorGroups()

            }
        }

    }, [failed]);

    useEffect(() => {
        if (updated.length > 0) {
            setLoadingMessage(`Updating ${target}... (${failed.length + updated.length}/${selected.filter((element) => element.name != "Select All").length})`);
            const updatedAppSegment = updated[updated.length - 1];
            appendConsoleSeperatorSecondary();
            appendConsole(`\n\tStatus: Updated \n\tName: ${updatedAppSegment}`);
            if (failed.length + updated.length == selected.filter((element) => element.name != "Select All").length) {
                terminateSession(accessToken);
                outputResponseUserStatus();
                setSelected([]);
                getAppSegments()
                getAppConnectorGroups();
            }
        }
    }, [updated]);

    useEffect(() => {
        setSelected([]);
        setFiltered([])
        filter()
    }, [tenant])

    useEffect(() => {
        console.log(target)
        setSelected([]);
        setFiltered([])
        filter()
    }, [target])


    useEffect(() => {
        scrollToBottom();
    }, [outputConsole])

    useEffect(() => {
        scrollToTop();
    }, [isLoading])

    useEffect(() => {
        console.log(appSegments)
        setFiltered([])
        filter()
    }, [appSegments])

    useEffect(() => {
        console.log(appSegments)
        setFiltered([])
        filter()
    }, [appConnectorGroups])

    useEffect(() => {
        setSelected([]);
        setFiltered([])
        filter()
    }, [operation])

    useEffect(() => {
        console.log(selected)
    }, [selected])




    useEffect(() => {
        if (appSegments[tenant].length == []) {
            getAppSegments();
        }
        if (appConnectorGroups[tenant].length == []) {
            getAppConnectorGroups();
        }
        const JWT = Cookies.get('CF_Authorization');
        const decodedJWT = jwtDecode(JWT)
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const date = `${day}-${month}-${year}`;
        setDescriptionTag(`${date}/${decodedJWT.email}`)
    }, [])



    async function terminateSession(access_token) {
        //Signout
        setLoadingMessage("Terminating Session...");
        await SignOut(access_token);
        setLoading(false);
    }
    return (
        <Container className=' pt-4 px-5 text-white pb-6'>
            <Row>
                <Col>
                    <Form onSubmit={handleSubmit}>
                        <FormGroup controlId="company">
                            <Form.Label>
                                Select tenant
                            </Form.Label>
                            <Form.Select aria-label="Default select example" value={tenant} onChange={(e) => setTenant(e.target.value)} >
                                {
                                    Object.keys(groups).map((key, index) => (
                                        <option key={index} value={key}>{key}</option>
                                    ))

                                }
                            </Form.Select>
                        </FormGroup>

                        <FormGroup controlId="Operation" className='mt-4'>
                            <Form.Label>
                                Operation
                            </Form.Label>
                            <Form.Select required value={operation} onChange={(e) => setOperation(e.target.value)} >
                                <option value="Enable">Enable</option>
                                <option value="Disable">Disable</option>
                            </Form.Select>
                        </FormGroup>

                        <FormGroup controlId="Target" className='mt-4'>
                            <Form.Label>
                                Target
                            </Form.Label>
                            <Form.Select required value={target} onChange={(e) => setTarget(e.target.value)} >
                                <option value="App Segments">App Segments</option>
                                <option value="App Connector Groups">App Connector Groups</option>
                            </Form.Select>
                        </FormGroup>

                        {target === "App Segments" ?
                            <FormGroup controlId="appSegments" className='mt-4'>
                                <Form.Label>
                                    {appSegments[tenant].length === 0 ?
                                        <>
                                            <Spinner
                                                variant='light'
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                            />
                                            &nbsp;&nbsp;
                                        </> : <></>}
                                    App Segments
                                </Form.Label>
                                <Multiselect
                                    avoidHighlightFirstOption="true"
                                    placeholder='Select'
                                    showCheckbox="true"
                                    showArrow="true"
                                    selectedValues={selected}
                                    customArrow={<FontAwesomeIcon icon="fa-solid fa-angle-down" style={{ color: "#c6cbce", }} size='sm' />}
                                    options={filtered[tenant].length > 0 ? [{ name: "Select All" }, ...filtered[tenant]] : []}// Options to display in the dropdown
                                    displayValue="name" // Property name to display in the dropdown options
                                    onSelect={(selectedList, selectedItem) => evaluateSelect(selectedList, selectedItem)}
                                    onRemove={(selectedList, selectedItem) => evaluateRemove(selectedList, selectedItem)}
                                    ref={multiselectRef}
                                    loading={appSegments[tenant].length < 1}
                                    loadingMessage={"Loading App Segments"}
                                    emptyRecordMsg="No App Segments Found"
                                />
                            </FormGroup>
                            :
                            <FormGroup controlId="appConnectorGroups" className='mt-4'>
                                <Form.Label>
                                    {appConnectorGroups[tenant].length === 0 ?
                                        <>
                                            <Spinner
                                                variant='light'
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                            />
                                            &nbsp;&nbsp;
                                        </> : <></>}
                                    App Connector Groups
                                </Form.Label>
                                <Multiselect
                                    avoidHighlightFirstOption="true"
                                    placeholder='Select'
                                    showCheckbox="true"
                                    showArrow="true"
                                    selectedValues={selected}
                                    customArrow={<FontAwesomeIcon icon="fa-solid fa-angle-down" style={{ color: "#c6cbce", }} size='sm' />}
                                    options={filtered[tenant].length > 0 ? [{ name: "Select All" }, ...filtered[tenant]] : []}// Options to display in the dropdown
                                    displayValue="name" // Property name to display in the dropdown options
                                    onSelect={(selectedList, selectedItem) => evaluateSelect(selectedList, selectedItem)}
                                    onRemove={(selectedList, selectedItem) => evaluateRemove(selectedList, selectedItem)}
                                    ref={multiselectRef}
                                    loading={appConnectorGroups[tenant].length < 1}
                                    loadingMessage={"Loading App Connector Groups"}
                                    emptyRecordMsg="No App Connector Groups Found"
                                />
                            </FormGroup>

                        }
                        <FormGroup controlId="description" className='mt-4'>
                            <Form.Label>
                                Description (Will be added to the description for each segment/group)
                            </Form.Label>

                            <InputGroup className="">
                                <InputGroup.Text id="basic-addon2">{descriptionTag}</InputGroup.Text>
                                <Form.Control type='text' required value={description} onChange={(e) => setDescription(e.target.value)} placeholder='Some Description...' />
                            </InputGroup>
                        </FormGroup>





                        <Button className='mt-4 text-light' type='submit' disabled={isLoading || selected.length < 1} variant={operation === "Enable" ? "success" : "danger"} >
                            {isLoading ?
                                <span>
                                    <Spinner
                                        variant='light'
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    {"  " + loadingMessage}
                                </span> : `${operation} ${target} Disaster Recovery`}
                        </Button>
                    </Form>
                </Col>
            </Row>
            <Row className='mt-5 '>
                <Col>
                    <ProgressBar className='mb-2' now={isLoading ? (updated.length + failed.length) / selected.filter((app_segment) => app_segment.name != "Select All").length * 100 : 0} />
                </Col>
            </Row>
            <Row className='mt-0 text-center'>
                <Col className=''>
                    <textarea value={outputConsole} className='w-100 bg-dark-subtle text-rheintec-blue output-terminal' rows="20" readOnly ref={textareaRef}>
                    </textarea>
                </Col>

            </Row>

        </Container >

    );

}

export default DisasterRecoveryTab;